// extracted by mini-css-extract-plugin
export default {"text":"Text_text__MzWYW","white":"Text_white__mYJAu","section":"Text_section__pe8aj","richText":"Text_richText__lZ1vg"};